export default __webpack_public_path__ + "static/media/image6tum.bdfa53cf.jpg";